import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { ProjectCard } from "@/components/Cards";
import SectionHeader from "@/components/SectionHeader";
import PageSEO from "@/components/PageSEO";

const SECTIONS = ["SMEs", "Business Expansion", "Commercial Ventures", "Growth Projects", "Strategic Partnerships"];

export default function Strategic() {
  const [projects, setProjects] = useState([]);
  useEffect(() => { http.get("/projects?sector=strategic").then(r => setProjects(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <PageSEO
        title="Strategic Business Investment Opportunities in Nigeria"
        description="Mayoto Strategic Business Investments — structured participation in SMEs, business expansion and growth projects with strong fundamentals and long-term value creation potential."
        canonicalPath="/strategic"
      />
      <section className="mayo-grain">
        <div className="container-wide py-20 lg:py-24 grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <p className="text-[#00b4d8] font-display font-bold tracking-[0.25em] text-xs">STRATEGIC INVESTMENTS</p>
            <h1 className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[0.95] text-[#0a1128]" data-testid="strategic-title">Strategic Business Investments.</h1>
            <p className="mt-5 text-slate-600 max-w-xl leading-relaxed">
              Mayoto explores carefully selected businesses and projects with growth potential and sustainable economic value. Not every business will generate profit — every opportunity is evaluated on its own merits.
            </p>
          </div>
          <div className="rounded-3xl overflow-hidden aspect-[4/3]">
            <img src="https://images.unsplash.com/photo-1716399233137-5f18a8e3520d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxuaWdlcmlhbiUyMGVudHJlcHJlbmV1cnMlMjBtZWV0aW5nfGVufDB8fHx8MTc4NTUzOTg0Mnww&ixlib=rb-4.1.0&q=85" alt="Strategic investments" className="h-full w-full object-cover" />
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container-wide">
          <div className="flex flex-wrap gap-3 mb-10">
            {SECTIONS.map(s => (
              <span key={s} className="text-xs font-display font-bold tracking-widest text-[#0a1128] bg-white border border-slate-200 rounded-full px-4 py-2">{s.toUpperCase()}</span>
            ))}
          </div>
          <SectionHeader eyebrow="SELECTED VENTURES" title="Live strategic investments." />
          <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {projects.map(p => <ProjectCard key={p.id} p={p} />)}
            {projects.length === 0 && <div className="text-slate-500">No ventures yet. Please check back soon.</div>}
          </div>
        </div>
      </section>
    </div>
  );
}
